import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Col, Container, Row } from "react-bootstrap";
import "../../styles/hydiene-system/hydiene.css";
import { selectUser } from "../../components/auth/auth.selector";
import HelmetWrapper from "../../HelmetWrapper";
import { currentDateOfTheMonth } from "../../components/common-data/Converts";
import CommonStructured from "../../components/common-components/CommonStructured";
import CmnFilters from "../../components/lead-management/common/CmnFilters";
import { fetchHygineGymwiseData } from "../../redux/hygiene-reducers/hygieneSlice";
import GymwiseTaskLists from "../../components/hygiene-system/gymwise-tasks/GymwiseTaskLists";

const HygineGymwise = () => {
  const dispatch = useDispatch();
  const userInfoData = useSelector(selectUser);
  const { hygineGymwiseDataLoading } = useSelector((state) => state.hygiene);

  const isAdmin = userInfoData?.account_type === "admin";
  const isGym = userInfoData?.account_type === "gym";

  const isManagerRole = [
    "cluster_manager",
    "fitness_manager",
    "sales_manager",
    "club_manager",
  ].includes(userInfoData?.account_type);

  const [pageLimit, setPageLimit] = useState(10);
  const [isPage, setIsPage] = useState(0);
  const iniAllFilter = {
    selectedGym: !isAdmin && !isManagerRole
      ? {
          label: isGym ? userInfoData?.name : userInfoData?.gym_name || "",
          value:
            userInfoData?.gym_id ||
            userInfoData?.user_id ||
            userInfoData?.uid ||
            "",
        }
      : "",
    selectedStartDate: currentDateOfTheMonth,
    selectedHygineCategory: "",
    selectedTaskPriority: "",
    selTaskInterval: "",
    selMediaType: "",
    selAssignee:
      !isAdmin && !isManagerRole
        ? {
            lavel: userInfoData?.account_type,
            value: userInfoData?.account_type,
          }
        : "",
    isActive: "",
    searchString: "",
  };
  const [allFilters, setAllFilters] = useState(iniAllFilter);
  const iniFilters = {
    limit: pageLimit || 10,
    page: isPage + 1,
    gym_id: allFilters.selectedGym?.value || "",
    task_date: allFilters.selectedStartDate || "",
    category: allFilters.selectedHygineCategory?.value || "",
    priority: allFilters.selectedTaskPriority?.value || "",
    time_unit: allFilters.selTaskInterval?.value || "",
    media_type: allFilters.selMediaType?.value || "",
    stakeholders: allFilters.selAssignee?.value || "",
    status: allFilters.isActive?.value || "",
  };
  const [filters, setFilters] = useState(iniFilters);
  const [searchFilterApplied, setSearchFilterApplied] = useState(false);

  const onResetFilters = () => {
    setAllFilters(iniAllFilter);
    setIsPage(0);
    setFilters(iniFilters);
  };

  const onClickSearch = () => {
    setIsPage(0);

    if (allFilters.searchString) {
      setSearchFilterApplied(true);
      setFilters((prevs) => ({ ...prevs, search: allFilters.searchString }));
    }
  };

  function getHygieneTasks(filters) {
    dispatch(
      fetchHygineGymwiseData({
        filters: filters,
        token: userInfoData?.token,
      })
    );
  }

  useEffect(() => {
    getHygieneTasks(filters);
  }, [filters]);

  useEffect(() => {
    setFilters((prevs) => ({
      ...prevs,
      limit: pageLimit || 10,
      page: isPage + 1,
      gym_id: allFilters.selectedGym?.value || "",
      task_date: allFilters.selectedStartDate || "",
      category: allFilters.selectedHygineCategory?.value || "",
      priority: allFilters.selectedTaskPriority?.value || "",
      time_unit: allFilters.selTaskInterval?.value || "",
      media_type: allFilters.selMediaType?.value || "",
      stakeholders: allFilters.selAssignee?.value || "",
      status: allFilters.isActive?.value || "",
    }));
  }, [
    allFilters.selectedHygineCategory,
    allFilters.selectedTaskPriority,
    allFilters.selTaskInterval,
    allFilters.selMediaType,
    allFilters.selAssignee,
    allFilters.isActive,
    allFilters.selectedGym,
    allFilters.selectedStartDate,
    pageLimit,
    isPage,
  ]);

  return (
    <HelmetWrapper title="WTF: Daily Operation Checklist Gymwise">
      <Container className="bg-cloud-k px-50px gobal-container" fluid>
        <Row>
          <Col>
            <CommonStructured
              pageHeading={"Daily Operation Checklist Gymwise"}
              isReload={() => {
                getHygieneTasks(filters);
              }}
            />
          </Col>
        </Row>
        <Row>
          <Col>
            <CmnFilters
              from={"hygine-submitted-tasks"}
              userInfoData={userInfoData}
              onClickReset={onResetFilters}
              filters={allFilters}
              setFilters={setAllFilters}
              onClickSearch={onClickSearch}
              searchFilterApplied={searchFilterApplied}
              isLoading={hygineGymwiseDataLoading}
            />
          </Col>
        </Row>
        <Row>
          <Col>
            <GymwiseTaskLists
              userInfoData={userInfoData}
              isPage={isPage}
              setIsPage={setIsPage}
              pageLimit={pageLimit}
              setPageLimit={setPageLimit}
              prevAllFilters={allFilters}
            />
          </Col>
        </Row>
      </Container>
    </HelmetWrapper>
  );
};

export default HygineGymwise;
